import { useModal } from "@/Contexts";
import { useTerminalsState } from "@/States/Terminals";
import { useGlobalAlert } from "@/States/globalAlert";
import { trpc } from "@/Utils/trpc";
import { useNavigate } from "@/Utils/useNavigate";
import { useConfig } from "@/api/hooks/useConfig";
import useCustomers from "@/api/hooks/useCustomers";
import ModalContainer from "@/components/modalContainer";
import { useMultiSelectContext } from "@/components/pageCards/multiListTable/multiSelectContext";
import { useTrans } from "@/translations";

export const DeleteTenantModal: React.FC<{
  customerId: string;
  customerName: string;
}> = ({ customerId, customerName }) => {
  const navigate = useNavigate();
  const { t } = useTrans();
  const { isRealEstate } = useConfig();
  const { currentTerminal } = useTerminalsState();
  const { hideModal } = useModal();
  const { refetchCustomers } = useCustomers();
  const { setGlobalAlert } = useGlobalAlert();
  const { setSelectedIds } = useMultiSelectContext();

  const { mutate: deleteCustomerFromStorage } =
    trpc.customerStorage.delete.useMutation();

  const { mutate: deleteTenantEmailJobs } =
    trpc.config.deleteEmailJobsByTenantId.useMutation();

  const { mutateAsync, isPending: isLoading } =
    trpc.customers.delete.useMutation({
      onSuccess: () => {
        setGlobalAlert({
          type: "success",
          message: "systemMessages:customerDeleted",
        });

        if (isRealEstate && currentTerminal) {
          deleteCustomerFromStorage({
            terminalId: currentTerminal.id,
            customerId,
          });
        }

        deleteTenantEmailJobs({
          tenantId: customerId,
        });

        refetchCustomers();
        setSelectedIds([]);
        hideModal();
      },

      onError: (error) => {
        setGlobalAlert({
          type: "error",
          message: error.message,
        });
      },
    });

  const onConfirm = async () => {
    await mutateAsync({ id: customerId });
    navigate("/customer/manage");
  };

  return (
    <ModalContainer
      title={"actions:deleteCustomer"}
      onConfirm={onConfirm}
      onCancel={hideModal}
      onConfirmLoading={isLoading}
      onConfirmDisabled={isLoading}
      onConfirmText="actions:confirm"
    >
      <div className="pt-3">
        <p>
          {t("hints:deleteTenantConfirmation")} {customerName}?
        </p>
      </div>
    </ModalContainer>
  );
};
